import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 示例state
    count: 0,
    // 用户信息
    userInfo: null,
    // 是否已登录
    isLoggedIn: false,
    // openid
    openid: null
  },
  mutations: {
    increment(state) {
      state.count++
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      state.isLoggedIn = true;
      // 保存openid到localStorage
      if (userInfo.openid) {
        state.openid = userInfo.openid;
        localStorage.setItem('openid', userInfo.openid);
      }
      // 保存到localStorage
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      localStorage.setItem('isLoggedIn', 'true');
    },
    clearUserInfo(state) {
      state.userInfo = null;
      state.isLoggedIn = false;
      state.openid = null;
      // 清除localStorage
      localStorage.removeItem('userInfo');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('openid');
    }
  },
  actions: {
    increment({ commit }) {
      commit('increment')
    },
    // 初始化用户状态
    initUserState({ commit }) {
      const userInfo = localStorage.getItem('userInfo');
      const isLoggedIn = localStorage.getItem('isLoggedIn');
      const openid = localStorage.getItem('openid');
      
      if (userInfo && isLoggedIn === 'true' && openid) {
        commit('setUserInfo', JSON.parse(userInfo));
      }
    }
  },
  modules: {
    // 可扩展模块
  }
}) 